const DATA_TESTID_PREFIX = 'ta-';

const COMPONENT_TESTID = {
  MODAL_COMPONENT: `${DATA_TESTID_PREFIX}modal-component`,
  PRODUCT_COMPONENT: `${DATA_TESTID_PREFIX}product-component`,
};

const LOGIN_PAGE_AUTOMATION_TESTID = {
  LOGIN_EMAIL_INPUT: `${DATA_TESTID_PREFIX}login-email-input`,
  LOGIN_PASSWORD_INPUT: `${DATA_TESTID_PREFIX}login-password-input`,
  LOGIN_CONFIRM_BUTTON: `${DATA_TESTID_PREFIX}login-confirm-button`,
};

const MENU_AUTOMATION_TESTID = {
  RE_LOGO_NAV_ITEM: `${DATA_TESTID_PREFIX}re-logo-nav-item`,
  PROFILE_NAV_ITEM: `${DATA_TESTID_PREFIX}profile-nav-item`,
  EXCHANGES_AND_RETURNS_NAV_ITEM: `${DATA_TESTID_PREFIX}exchanges-and-returns-nav-item`,
  REPORTS_NAV_ITEM: `${DATA_TESTID_PREFIX}reports-nav-item`,
  BATCH_COLLECTION_NAV_ITEM: `${DATA_TESTID_PREFIX}batch-collection-nav-item`,
  OPEN_STORE_SELECTION_NAV_ITEM: `${DATA_TESTID_PREFIX}open-store-selection-nav-item`,
};

const DASHBOARD_AUTOMATION_TESTID = {
  WARNING_BOX: `${DATA_TESTID_PREFIX}warning-box`,
};

const CONSIGNMENT_LIST_AUTOMATION_TESTID = {
  CONSIGNMENTS_LIST: `${DATA_TESTID_PREFIX}consignments-list`,
  CONSIGNMENT_FILTER: `${DATA_TESTID_PREFIX}consignment-filter`,
  CONSIGNMENT_FILTER_FORM: `${DATA_TESTID_PREFIX}consignment-filter-form`,
  CONSIGNMENT_SEARCH_BAR: `${DATA_TESTID_PREFIX}consignment-search-bar`,
};

const CONSIGNMENT_DETAILS_AUTOMATION_TESTID = {
  DELIVERY_MODE_SELECT: `${DATA_TESTID_PREFIX}delivery-mode-select`,
  CONFIRM_COLLECT_BUTTON: `${DATA_TESTID_PREFIX}confirm-collect-button`,
  PRINT_COLLECT_RECEIPT_BUTTON: `${DATA_TESTID_PREFIX}print-collect-receipt-button`,
  CUSTOMER_INFO_DIV: `${DATA_TESTID_PREFIX}customer-info-div`,
  CUSTOMER_ADDRESS_DIV: `${DATA_TESTID_PREFIX}customer-address-div`,
  PAYMENT_INFOS_DIV: `${DATA_TESTID_PREFIX}payment-infos-div`,
  FAB_SUPPORT_WRAPPER: `${DATA_TESTID_PREFIX}fab-support-wrapper`,
  FAB_SUPPORT_TOGGLE: `${DATA_TESTID_PREFIX}fab-support-toggle`,
  CONSIGNMENT_DETAILS_HEADER: `${DATA_TESTID_PREFIX}consignment-details-header`,
  COPY_CONSIGMENT_CODE_BUTTON: `${DATA_TESTID_PREFIX}copy-consignment-code-button`,
  CONSIGNMENT_STATUS_TEXT: `${DATA_TESTID_PREFIX}consignment-status-text`,
  TRACKING_HISTORY_ACCORDION: `${DATA_TESTID_PREFIX}tracking-history-accordion`,
  CONSIGNMENT_ITEMS_LIST: `${DATA_TESTID_PREFIX}consignment-items-list`,
  SUBMIT_REPORT_FAIL: `${DATA_TESTID_PREFIX}submit-report-fail`,
  REFUSE_ATTENDANCE_BUTTON: `${DATA_TESTID_PREFIX}refuse-attendance-button`,
  CONFIRM_ATTENDANCE_BUTTON: `${DATA_TESTID_PREFIX}confirm-attendance-button`,
  CONFIRM_INVOICE_BUTTON: `${DATA_TESTID_PREFIX}confirm-invoice-button`,
  PRINT_LABEL_SIZE_SELECT: `${DATA_TESTID_PREFIX}print-label-size-select`,
  PRINT_LABEL_BUTTON: `${DATA_TESTID_PREFIX}print-label-button`,
  PRINT_LABEL_DISPLAY_SMALL: `${DATA_TESTID_PREFIX}print-label-display-small`,
  PRINT_LABEL_DISPLAY_LARGE: `${DATA_TESTID_PREFIX}print-label-display-large`,
  COPY_BUTTON_CUSTOMER_NAME: `${DATA_TESTID_PREFIX}copy-button-customer-name`,
  COPY_BUTTON_CUSTOMER_ID: `${DATA_TESTID_PREFIX}copy-button-customer-id`,
  COPY_BUTTON_CUSTOMER_EMAIL: `${DATA_TESTID_PREFIX}copy-button-customer-email`,
  COPY_BUTTON_CUSTOMER_PHONE: `${DATA_TESTID_PREFIX}copy-button-customer-phone`,
  COPY_BUTTON_ADDRESS_STREET: `${DATA_TESTID_PREFIX}copy-button-address-street`,
  COPY_BUTTON_ADDRESS_NUMBER: `${DATA_TESTID_PREFIX}copy-button-address-number`,
  COPY_BUTTON_ADDRESS_COMPLEMENT: `${DATA_TESTID_PREFIX}copy-button-address-complement`,
  COPY_BUTTON_ADDRESS_DISTRICT: `${DATA_TESTID_PREFIX}copy-button-address-district`,
  COPY_BUTTON_ADDRESS_TOWN: `${DATA_TESTID_PREFIX}copy-button-address-town`,
  COPY_BUTTON_ADDRESS_ISO_CODE: `${DATA_TESTID_PREFIX}copy-button-address-iso-code`,
  COPY_BUTTON_ADDRESS_POSTAL_CODE: `${DATA_TESTID_PREFIX}copy-button-address-postal-code`,
  COPY_BUTTON_PAYMENT_FREIGHT_CHARGES: `${DATA_TESTID_PREFIX}copy-button-payment-freight-charges`,
  COPY_BUTTON_PAYMENT_TOTAL: `${DATA_TESTID_PREFIX}copy-button-payment-total`,
  INVOICE_CODE_OPTION_KEY: `${DATA_TESTID_PREFIX}invoice-code-option-key`,
  INVOICE_CODE_OPTION_NUMBER: `${DATA_TESTID_PREFIX}invoice-code-option-number`,
};

const BATCH_COLLECTION_AUTOMATION_TESTID = {
  CONSIGNMENT_LIST_DIV: `${DATA_TESTID_PREFIX}consignment-list-div`,
  CONFIRM_SELECTION_BUTTON: `${DATA_TESTID_PREFIX}confirm-selection-button`,
  PRINT_COLLECTION_PROOF_BUTTON: `${DATA_TESTID_PREFIX}print-collection-proof-button`,
  CONFIRM_COLLECT_BUTTON: `${DATA_TESTID_PREFIX}confirm-collect-button`,
  CONSIGNMENT_CODE_SELECT: `${DATA_TESTID_PREFIX}consignment-code-select`,
  DELIVERY_MODE_SELECT: `${DATA_TESTID_PREFIX}delivery-mode-select`,
  APPLY_FILTER_BUTTON: `${DATA_TESTID_PREFIX}apply-filter-button`,
  CARRIERS_WRAPPER_DIV: `${DATA_TESTID_PREFIX}carriers-wrapper-div`,
  BATCH_COLLECTION_HISTORY: `${DATA_TESTID_PREFIX}batch-collection-history`,
};

const PERFORMANCE_PAGE_AUTOMATION_TESTID = {
  APPLY_FILTER_BUTTON: `${DATA_TESTID_PREFIX}apply-filter-button`,
  EXPORT_BUTTON: `${DATA_TESTID_PREFIX}export-button`,
  DEFAULT_FILTER_BUTTON: `${DATA_TESTID_PREFIX}default-filter-button`,
  DATA_TABLE_DIV: `${DATA_TESTID_PREFIX}data-table-div`,
};

const PROFILE_PAGE_AUTOMATION_TESTID = {
  REQUEST_CHANGE_BUTTON: `${DATA_TESTID_PREFIX}request-change-button`,
  LOGOUT_BUTTON: `${DATA_TESTID_PREFIX}logout-button`,
  OPENING_DAYS_HISTORY_CONTENT: `${DATA_TESTID_PREFIX}opening-days-history-content`,
  OPENING_DAYS_HISTORY_BUTTON: `${DATA_TESTID_PREFIX}opening-days-history-button`,
  OPENING_DAYS_DIV: `${DATA_TESTID_PREFIX}opening-days-div`,
  CANCEL_OPENING_DAYS_CHANGES_BUTTON: `${DATA_TESTID_PREFIX}cancel-opening-days-changes-button`,
  CONFIRM_OPENING_DAYS_CHANGES_BUTTON: `${DATA_TESTID_PREFIX}confirm-opening-days-changes-button`,
  STORE_INFOS_DIV: `${DATA_TESTID_PREFIX}store-infos-div`,
  STORE_ADDRESS_DIV: `${DATA_TESTID_PREFIX}store-address-div`,
};

const PICKING_MANAGEMENT_PAGE_AUTOMATION_TESTID = {
  PRODUCT_CARD_WRAPPER: `${DATA_TESTID_PREFIX}product-card-wrapper`,
};

export const TEST_IDS = {
  ...COMPONENT_TESTID,
  ...LOGIN_PAGE_AUTOMATION_TESTID,
  ...MENU_AUTOMATION_TESTID,
  ...DASHBOARD_AUTOMATION_TESTID,
  ...CONSIGNMENT_LIST_AUTOMATION_TESTID,
  ...CONSIGNMENT_DETAILS_AUTOMATION_TESTID,
  ...BATCH_COLLECTION_AUTOMATION_TESTID,
  ...PERFORMANCE_PAGE_AUTOMATION_TESTID,
  ...PROFILE_PAGE_AUTOMATION_TESTID,
  ...PICKING_MANAGEMENT_PAGE_AUTOMATION_TESTID,
};
